import React, { useContext } from 'react';
import RadioButtonTab from '../../../../../../../components/RadioButton/RadioButtonTab';
import { StepperContext } from '../../../../../../../providers/stepper.provider';
import { EvOwner } from '../../../../../../../GraphQL/Types';
import { LeadContext } from '../../../../../../../providers/lead.provider';
import { enterPropertyTypeEventPixel } from '../../../../../../../utils/facebookPixelEvents';

const EvOwnerStep = ({ onNext, onPrevious }) => {
  const { solarInquiryData, setSolarInquiryData, setIsRentedProperty, isProduction } =
    useContext(StepperContext);
  const { addLeadStep } = useContext(LeadContext);

  return (
    // <div className="sm:ml-[130px] ml-[25px] mr-[25px]  h-[60vh]">
    <div className="xl:ml-[130px] sm:ml-[50px] ml-[25px] mr-[25px] h-[60vh]">
      <fieldset>
        <div className="mb-[40px] ">
          <h3 className="sm:text-[32px] text-[24px] leading-[40px] text-primary_black font-forma-djr-text-regular mb-[20px]">
            Do you charge an Electric Vehicle at home?
          </h3>

          <div className="p-1 max-w-[188px]">
            <div className="p-2">
              <ul className="">
                <li className="my-5">
                  <RadioButtonTab
                    id="ev-yes"
                    value={EvOwner.Yes}
                    onChange={(e) =>
                      setSolarInquiryData({
                        ...solarInquiryData,
                        evOwner: e.currentTarget.value
                      })
                    }
                    name="evOwner"
                    checked={solarInquiryData.evOwner === EvOwner.Yes}
                    label="Yes"
                    className={
                      'h-[50px] justify-start peer-checked:border-solid !rounded-none border-[1px] dark:peer-checked:text-primary text-primary bg-white peer-checked:bg-secondary_white peer-checked:text-primary hover:bg-gray-200 hover:text-primary dark:bg-white dark:text-primary relative'
                    }
                    showIcon={true}
                    index={0}
                    labelPrefix={true}
                  />
                </li>
                <li className="my-5">
                  <RadioButtonTab
                    id="ev-no"
                    value={EvOwner.No}
                    onChange={(e) =>
                      setSolarInquiryData({
                        ...solarInquiryData,
                        evOwner: e.currentTarget.value
                      })
                    }
                    name="evOwner"
                    checked={solarInquiryData.evOwner === EvOwner.No}
                    label="No"
                    className={
                      'h-[50px] justify-start peer-checked:border-solid border-[1px] !rounded-none dark:peer-checked:text-primary text-primary bg-white peer-checked:bg-secondary_white peer-checked:text-primary hover:bg-gray-200 hover:text-primary dark:bg-white dark:text-primary  relative'
                    }
                    showIcon={true}
                    index={1}
                    labelPrefix={true}
                  />
                </li>
                <li className="my-5">
                  <RadioButtonTab
                    id="ev-not-yet"
                    value={EvOwner.Not_Yet}
                    onChange={(e) =>
                      setSolarInquiryData({
                        ...solarInquiryData,
                        evOwner: e.currentTarget.value
                      })
                    }
                    name="evOwner"
                    checked={solarInquiryData.evOwner === EvOwner.Not_Yet}
                    label="Not Yet"
                    className={
                      'h-[50px] justify-start peer-checked:border-solid border-[1px] !rounded-none dark:peer-checked:text-primary text-primary bg-white peer-checked:bg-secondary_white peer-checked:text-primary hover:bg-gray-200 hover:text-primary dark:bg-white dark:text-primary  relative'
                    }
                    showIcon={true}
                    index={2}
                    labelPrefix={true}
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="text-left ml-[5px] my-8">
          <button
            className="py-3 text-lg rounded-md cursor-pointer bg-primary font-forma-djr-text-regular px-14 text-secondary_white border-primary disabled:cursor-not-allowed disabled:bg-neutral disabled:text-gray-500 hover:opacity-80"
            disabled={!solarInquiryData.evOwner}
            onClick={async () => {
              if (isProduction) {
                // await enterPropertyTypeEventPixel({
                //   propertyType: solarInquiryData.onHome
                // });
              }
              await addLeadStep({ evOwner: solarInquiryData.evOwner }, 'evOwner');

              onNext();
            }}>
            Next
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default EvOwnerStep;
